// Copyright (c) 2022 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import type { Empty } from "@bufbuild/protobuf/wkt"
import * as Actions from "../actions"
import * as Slice from "../slices/stats"
import { showSnackBar } from "../../snackbar/actions"
import { executorMutation, postExpectationService } from "../../../app/rpc"
import { DeleteLeaveRequestSchema } from "../../../generated/legebill/site/postexpectation/v4/post_expectation_pb"

type DeleteLeaveRpc = (payload: Actions.DeleteLeavePayload) => Observable<Empty>

export const deleteLeave = (deleteLeaveRpc: DeleteLeaveRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.deleteLeave.match),
      mergeMap(action => deleteLeaveRpc(action.payload)
        .pipe(
          mergeMap(_ => concat(
            of(Slice.deleteLeave(action.payload.deleteLeaveRequest.id ?? "")),
            of(Actions.refreshMemberExpectations({
              siteId: action.payload.deleteLeaveRequest.siteId,
              membershipId: action.payload.membershipId,
              startDate: action.payload.date,
              endDate: action.payload.date,
            })),
          )),
          catchError(() => of(showSnackBar({
            message: t({ id: "msg_delete_leave_failed", message: "Failed to delete leave. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const deleteLeaveRpc = (payload: Actions.DeleteLeavePayload): Observable<Empty> =>
  executorMutation(() => postExpectationService.deleteLeave(create(DeleteLeaveRequestSchema, payload.deleteLeaveRequest)))

export default deleteLeave(deleteLeaveRpc)
